import { render, staticRenderFns } from "./inicio.vue?vue&type=template&id=305e83b1&"
import script from "./inicio.vue?vue&type=script&lang=js&"
export * from "./inicio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports